import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Form, Input, Button } from "antd";
import userServiceApi from "../../api/userServiceApi";
import Logo from "../../../src/assets/images/PoweredNew.png";
import { toast } from "react-toastify";
import "./ResetPassword.scss"
import backArrow from "../../assets/images/back-arrow.svg";

export default function ResetPasswordForm() {
  const param = useParams();
  const token = param.token;

 const [, setLoading] = useState(false);
  const navigate = useNavigate();
  // const textInput = useRef(null);
  const [form] = Form.useForm();

  const handleReset = async (values) => {
    if (values && values.newPassword && values.confirmPassword) {
      if (values.newPassword !== values.confirmPassword) {
        toast.error("Passwords does not match");
      } else {
        setLoading(true);
        try {
          const response = await fetch(userServiceApi.resetPassword(token), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ newPassword: values.newPassword }),
          });
          if (response.ok) {
            const res = await response.text()
            navigate(`/login/${res}`);
            toast.success("Password successfully created");
          }
          else {
            const res = await response.json()
            toast.error(res.message)
          }
        } catch (error) {
          console.log('Error in reset password:', error);
          if (error.message) {
            toast.error(error.message)
          }
        }
        finally {
          setLoading(false);
        }
      }
    }
  };
  return (
    <div className="tabContainer" style={{ minHeight: "fit-content" }}>
      <div className="main-container" style={{ paddingTop: "5px" }}>
        <div className="header-container">
          <div className="backbtn-container">
            <img src={backArrow} alt="" onClick={() => navigate("/")} />
            <p>Create Password</p>
          </div>
        </div>

        <div className="formInfoStyle changePassword">
          <Form
            name="control-hooks"
            className="organizationForm"
            form={form}
            autoComplete="off"
            onFinish={handleReset}
          >
            <div className="formInfoRow">
              <div className="formInfoCol">
                <Form.Item
                  name="newPassword"
                  label="New Password"
                  hasFeedback
                  rules={[
                    { required: true, message: 'Please input your new password!' },
                    { min: 8, message: 'Password must be at least 8 characters long!' },
                    {
                      pattern: /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*])(?!.*\s)/,
                      message: 'Password must include uppercase, lowercase, number, special character and must not contain spaces!',
                    },
                  ]}
                >
                  <Input.Password required={true} type="password" placeholder="New Password" />
                </Form.Item>
              </div>
            </div>

            <div className="formInfoRow">
              <div className="formInfoCol">
                <Form.Item
                  name="confirmPassword"
                  label="Confirm Password"
                  dependencies={['newPassword']}  // Add dependencies to revalidate when 'newPassword' changes
                  hasFeedback  // Provides feedback to the user as they type
                  rules={[
                    { required: true, message: 'Please input your new password!' },
                    // { min: 8, message: 'Password must be at least 8 characters long!' },
                    // {
                    //   pattern: /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*])/,
                    //   message: 'Passwords do not match',
                    // },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue('newPassword') === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error('Passwords do not match'));
                      },
                    }),
                  ]}
                >
                  <Input.Password required={true} type="password" placeholder="Confirm Password" />
                </Form.Item>
              </div>
            </div>

            <div className="formInfoRow">
              <div className="formInfoCol">

                <Form.Item label=" " colon={false}>
                  <div
                    className="pwdUpdateBtn"
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      width: "100%",
                    }}
                  >

                    <Button
                      className="greenBtn"
                      onClick={() => form.submit()}
                    >
                      Save
                    </Button>
                  </div>
                </Form.Item>
              </div>
            </div>
          </Form>
          <div className="footerlogo" >
            <div onClick={() => window.open("https://www.connectsu.co.uk/", '_blank')} style={{ cursor: "pointer" }}>
              <img src={Logo} alt="powered-logo" />
            </div>
          </div>
        </div>
      </div>
    </div>

  );
}
